import { Component } from "@builder.io/sdk";

export const newsletterFormLargeConfig: Component = {
  name: "Newsletter Form Large",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "newsletter-form-large",
      friendlyName: "Section ID",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "JOIN the 34,000+\nCare Indeed Community",
      friendlyName: "Main Heading",
      helperText:
        "Primary heading text that encourages users to join the community (use \\n for line breaks)",
      required: true,
    },
    {
      name: "subheading",
      type: "string",
      defaultValue:
        "Get the latest home care news, tips, and resources straight to your inbox.",
      friendlyName: "Subheading",
      helperText:
        "Supporting text that explains the benefits of subscribing to the newsletter",
      required: true,
    },
    {
      name: "emailPlaceholder",
      type: "string",
      defaultValue: "Email Address",
      friendlyName: "Email Placeholder",
      helperText: "Placeholder text shown in the email input field",
      advanced: true,
    },
    {
      name: "buttonText",
      type: "string",
      defaultValue: "Subscribe to Our Newsletter",
      friendlyName: "Button Text",
      helperText: "Text displayed on the subscription button",
      advanced: true,
    },
    {
      name: "successHeading",
      type: "string",
      defaultValue: "Thank you for joining the Care Indeed Community!",
      friendlyName: "Success Heading",
      helperText: "Heading shown after successful subscription",
      advanced: true,
    },
    {
      name: "successMessage",
      type: "string",
      defaultValue:
        "You'll get the latest home care news, tips, and resources straight to your inbox.",
      friendlyName: "Success Message",
      helperText: "Message shown after successful subscription",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "string",
      friendlyName: "Background Color",
      defaultValue: "secondary-500",
      enum: ["secondary-500", "primary-500", "neutral-600"],
      helperText:
        "Background color for the newsletter section: secondary-500 (Teal), primary-500 (Orange), or neutral-600 (Dark Gray)",
      advanced: true,
    },
    {
      name: "textAlignment",
      type: "string",
      friendlyName: "Text Alignment",
      defaultValue: "center",
      enum: ["left", "center"],
      helperText:
        "Alignment of the text content: left or center (responsive: center on mobile, left on desktop)",
      advanced: true,
    },
    {
      name: "showIllustration",
      type: "boolean",
      defaultValue: true,
      friendlyName: "Show Success Illustration",
      helperText:
        "Whether to display the newsletter illustration in the success state",
      advanced: true,
    },
  ],
};
